const isInWeixin = /micromessenger/i.test(window.navigator.userAgent);
const isInTuanApp = /meituangroup/i.test(window.navigator.userAgent);
const isInWaiMaiApp = /meituanwaimai/i.test(window.navigator.userAgent);
const isMiniProgram = /miniprogram/i.test(window.navigator.userAgent);
const isMiniProgramTuan = /wxde8ac0a21135c07d/i.test(window.navigator.userAgent);
const isMiniProgramWaimai = /wx2c348cf579062e56/i.test(window.navigator.userAgent);
const isIos = /(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent);
const isAndroid = /(Android)/i.test(window.navigator.userAgent);
const isInDianPingApp = /dianping/i.test(window.navigator.userAgent);
const isMiniProgramDianping = /wx734c1ad7b3562129/i.test(window.navigator.userAgent);
const isDianPingDomain = window.location.host.indexOf('dianping') > -1;
const is51PingDomain = window.location.host.indexOf('51ping') > -1;

const getContainerName = () => {
    // 微信系 判断顺序不能改变
    if (isMiniProgramTuan) {
        return 'MiniProgramTuan';
    }
    if (isMiniProgramWaimai) {
        return 'MiniProgramWaimai';
    }
    if (isMiniProgramDianping) {
        return 'MiniProgramDianping';
    }
    if (isMiniProgram) {
        return 'MiniProgram';
    }
    if (isInWeixin) {
        return 'Weixin';
    }
    if (isInTuanApp) {
        return 'TuanApp';
    }
    if (isInWaiMaiApp) {
        return 'WaiMaiApp';
    }
    if (isInDianPingApp) {
        return 'DianPingApp';
    }

    return 'Other';
};

const containerName = getContainerName();
export {
    isIos,
    isAndroid,
    isInWeixin,
    isInTuanApp,
    isInWaiMaiApp,
    isMiniProgram,
    isMiniProgramTuan,
    isMiniProgramWaimai,
    containerName,
    isInDianPingApp,
    isMiniProgramDianping,
    isDianPingDomain,
    is51PingDomain,
};
